import React from "react";
import PropTypes from "prop-types";
import luxonGenerateConfig from "rc-picker/lib/generate/luxon";

import { DatePicker } from "antd";
import { DateTime } from "luxon";

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

const defaultProps = {
  value: null,
};

const MyDatePicker = DatePicker.generatePicker(luxonGenerateConfig);

function DateInput({ children, ...props }) {
  const value = props.value ? DateTime.fromJSDate(props.value) : null;
  const onChange = (value) => props.onChange(value ? value.toJSDate() : null);
  return (
    <MyDatePicker {...props} value={value} onChange={onChange}>
      {children}
    </MyDatePicker>
  );
}

DateInput.propTypes = propTypes;
DateInput.defaultProps = defaultProps;

export default DateInput;
